import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { WrapColorPicker } from '../../../widgets/index';

class LinksWithIconPreview extends Component {
    render() {
        return (
            <div className="ButtonPreview">
                <h4>{this.props.tagNameName}</h4>
                <p>{this.props.tag}</p>
                <div className="row">
                    <div className="col-xs-12 col-sm-3">
                        <span
                            className="spark-icon-cog"
                            style={{
                                color: this.props.colors.icon.color.normal,
                                fontSize: this.props.colors.icon['icon.size']
                            }}
                        />
                        <span
                            style={{
                                color: this.props.colors.color.normal,
                                fontSize: this.props.colors.size,
                                fontStyle: this.props.colors.style,
                                fontWeight: this.props.colors.weight,
                                textAlign: 'center',
                                fontFamily: this.props.colors.font,
                                textTransform: this.props.colors.textTransform,
                                textDecoration: this.props.colors.textDecoration.normal
                            }}
                        >
                            {' '}
                            Normal
                        </span>
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        <span
                            className="spark-icon-cog"
                            style={{
                                color: this.props.colors.icon.color.hover,
                                fontSize: this.props.colors.icon['icon.size']
                            }}
                        />
                        <span
                            style={{
                                color: this.props.colors.color.hover,
                                fontSize: this.props.colors.size,
                                fontStyle: this.props.colors.style,
                                fontWeight: this.props.colors.weight,
                                textAlign: 'center',
                                fontFamily: this.props.colors.font,
                                textTransform: this.props.colors.textTransform,
                                textDecoration: this.props.colors.textDecoration.hover
                            }}
                        >
                            {' '}
                            Hover
                        </span>
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        <span
                            className="spark-icon-cog"
                            style={{
                                color: this.props.colors.icon.color.active,
                                fontSize: this.props.colors.icon['icon.size']
                            }}
                        />
                        <span
                            style={{
                                color: this.props.colors.color.active,
                                fontSize: this.props.colors.size,
                                fontStyle: this.props.colors.style,
                                fontWeight: this.props.colors.weight,
                                textAlign: 'center',
                                fontFamily: this.props.colors.font,
                                textTransform: this.props.colors.textTransform,
                                textDecoration: this.props.colors.textDecoration.active
                            }}
                        >
                            {' '}
                            Active
                        </span>
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        <span
                            className="spark-icon-cog"
                            style={{
                                color: this.props.colors.icon.color.disabled,
                                fontSize: this.props.colors.icon['icon.size']
                            }}
                        />
                        <span
                            style={{
                                color: this.props.colors.color.disabled,
                                fontSize: this.props.colors.size,
                                fontStyle: this.props.colors.style,
                                fontWeight: this.props.colors.weight,
                                textAlign: 'center',
                                fontFamily: this.props.colors.font,
                                textTransform: this.props.colors.textTransform,
                                textDecoration: this.props.colors.textDecoration.disabled
                            }}
                        >
                            {' '}
                            Disabled
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

LinksWithIconPreview.propTypes = {
    title: PropTypes.object,
    subtitle: PropTypes.object,
    defaultLink: PropTypes.object,
    largePrice: PropTypes.object,
    tag: PropTypes.string
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.buttons.button, ...state.theme.button };
};

const mapDispatchToProps = dispatch => {
    return {
        //Generic action that can potentially kill a lot of boiler plate code
        onLeafPropertyChange: (layer, target, leaf) => {
            return event =>
                dispatch({
                    type: ActionTypes.LEAF_PROPERTY_CHANGE,
                    layer: layer,
                    target: target,
                    leaf: leaf,
                    value: event.target.value
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinksWithIconPreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/LinksWithIconPreview.js